import React from 'react';

import icoSuccess from 'assets/images/dialogs/ChargeSuccessful.svg';
import CurrencySign from 'components/price/CurrencySign.component';

import PageTitle from 'booking/components/common/PageTitle';
import Email from 'checkout/components/Email';
import EmailPopUp from 'clientProfile/components/bookingDetails/EmailPopUp';
import ProductsListComponent from 'clientProfile/components/bookingDetails/ProductsList';
import BookingDescription from 'clientProfile/components/bookingHistory/BookingDescription';
import ConversationDetailsComponent from 'clientProfile/components/common/ConversationDetails';
import { calculateTotalPrice } from 'clientProfile/utils';
import SimpleDialog from 'scheduler/components/SimpleDialog';

class BookingDetailsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEmailPopUp: false,
      sentSuccessPopUp: false,
    };
  }

  onRequestClose = () => void this.setState({ sentSuccessPopUp: false });

  render() {
    const { sentSuccessPopUp, showEmailPopUp } = this.state;
    const { sendRefundEmail, currentSalon, appointment, onAppointmentClick, clientId } = this.props;
    const { notes, procedures, transaction, sms_records: smsRecords, status } = appointment;

    const paidAppointment = status === 'paid' && transaction;

    let totalPrice = paidAppointment ? transaction.total : calculateTotalPrice(procedures);

    const voucher = transaction && transaction.otherAmount ? transaction.otherAmount : 0;

    totalPrice -= voucher;

    let deposit = 0;
    if (transaction && transaction.deposits && transaction.deposits.length > 0) {
      for (let i = 0; i < transaction.deposits.length; i += 1) {
        deposit += transaction.deposits[i].amount;
      }
    }

    const currentClientData = transaction && transaction.clients.find((el) => el.id === clientId);

    let clientProducts = [];
    let subTotal = 0;
    let tip = 0;
    if (currentClientData) {
      clientProducts = currentClientData.products;
      currentClientData.products.forEach((product) => {
        subTotal += product.finalPrice;
      });
      currentClientData.services.forEach((service) => {
        subTotal += service.finalPrice;
      });
      tip = transaction.tipAmount;
      if (tip) {
        subTotal += tip;
      }
    }

    let voucherAmount = 0;
    if (transaction && transaction.vouchers_used) {
      voucherAmount = transaction.vouchers_used.reduce((totalV, e) => totalV + e.used_amount, 0);
    }

    return (
      <div data-bem="BookingDetailsContainer" className="bd">
        {showEmailPopUp && (
          <React.Fragment>
            <EmailPopUp
              onCancel={() => void this.setState({ showEmailPopUp: false })}
              onSendEmail={(email) => {
                const receipt = document.getElementById('receipt');
                if (receipt) {
                  sendRefundEmail(email, `Receipt from ${currentSalon.name}`, receipt.outerHTML);
                  this.setState({ showEmailPopUp: false, sentSuccessPopUp: true });
                }
              }}
            />
            <div
              style={{
                visibility: 'hidden',
              }}
            >
              {transaction && <Email data={transaction} salonDetails={currentSalon} />}
            </div>
          </React.Fragment>
        )}
        {sentSuccessPopUp && (
          <SimpleDialog
            title=" "
            leftButtonText=""
            rightButtonText="OK, THANKS"
            onLeft={this.onRequestClose}
            onRight={this.onRequestClose}
            displayHeader="header-non"
            uniqueClass="wide-btn"
            isOpen={sentSuccessPopUp}
          >
            <div className="dialog-inner-title" />
            <img src={icoSuccess} alt="Request sent!" className="dialog-image" />
            <div className="dialog-inner-title text-center">Receipt sent!</div>
          </SimpleDialog>
        )}
        <PageTitle pageTitle="Booking Details" subTitle="" />
        <div className="sb">
          <div className="scheduler-booking booking-details">
            <BookingDescription appointment={appointment} onAppointmentClick={onAppointmentClick} detailsView />

            {paidAppointment && transaction && (
              <>
                <ProductsListComponent products={clientProducts} />
                <dl className="dl-horizontal cfix">
                  <dt>Tip</dt>
                  <dd>
                    <CurrencySign />
                    {tip}
                  </dd>

                  {subTotal !== totalPrice && (
                    <div>
                      <dt>Subtotal</dt>
                      <dd>
                        <CurrencySign value={subTotal} />
                      </dd>
                    </div>
                  )}

                  {deposit !== 0 && (
                    <div>
                      <dt>Deposit redeemed</dt>
                      <dd>
                        <CurrencySign />
                        {deposit}
                      </dd>
                    </div>
                  )}

                  <div>
                    <dt>Voucher redeemed</dt>
                    <dd>
                      <CurrencySign />
                      {voucherAmount}
                    </dd>
                  </div>

                  {transaction.cardAmount !== 0 && (
                    <div>
                      <dt>Paid via card in-store</dt>
                      <dd>
                        <CurrencySign /> - {transaction.cardAmount}
                      </dd>
                    </div>
                  )}

                  {transaction.onlineAmount !== 0 && (
                    <div>
                      <dt>Paid with SlickPay via stripe</dt>
                      <dd>
                        <CurrencySign /> - {transaction.onlineAmount}
                      </dd>
                    </div>
                  )}

                  {transaction.partCash !== 0 && (
                    <div>
                      <dt>Paid via Cash</dt>
                      <dd>
                        <CurrencySign /> - {transaction.partCash}
                      </dd>
                    </div>
                  )}

                  {transaction.otherAmount !== 0 && (
                    <div>
                      <dt>Paid via Other</dt>
                      <dd>
                        <CurrencySign /> - {transaction.otherAmount}
                      </dd>
                    </div>
                  )}

                  {transaction.additionalDiscount !== 0 && (
                    <div>
                      <dt>Additional Discount</dt>
                      <dd>
                        <CurrencySign />
                        {transaction.additionalDiscount || 0}
                      </dd>
                    </div>
                  )}
                </dl>

                <div className="ebtn border-b cfix">
                  <button
                    className="btn btn-violet pull-right"
                    onClick={() => void this.setState({ showEmailPopUp: true })}
                  >
                    Email receipt
                  </button>
                </div>
              </>
            )}

            <ConversationDetailsComponent notes={notes} smsRecords={smsRecords} showTitle />
          </div>
        </div>
      </div>
    );
  }
}

export default BookingDetailsContainer;
